<template>
    <svg
    :fill="svgColor"
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      :width="width"
    >
      <path
        d="m19.5,15H4.5c-2.481,0-4.5,2.019-4.5,4.5s2.019,4.5,4.5,4.5h15c2.481,0,4.5-2.019,4.5-4.5s-2.019-4.5-4.5-4.5Zm-4.243,3c-.166.469-.257.974-.257,1.5s.091,1.031.257,1.5h-6.515c.166-.469.257-.974.257-1.5s-.091-1.031-.257-1.5h6.515Zm-10.757,0c.827,0,1.5.673,1.5,1.5s-.673,1.5-1.5,1.5-1.5-.673-1.5-1.5.673-1.5,1.5-1.5Zm15,3c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5.673,1.5,1.5-.673,1.5-1.5,1.5ZM5.5,13h4c1.93,0,3.5-1.57,3.5-3.5v-4c0-1.93-1.57-3.5-3.5-3.5h-4c-1.93,0-3.5,1.57-3.5,3.5v4c0,1.93,1.57,3.5,3.5,3.5Zm-.5-7.5c0-.276.225-.5.5-.5h4c.275,0,.5.224.5.5v4c0,.276-.225.5-.5.5h-4c-.275,0-.5-.224-.5-.5v-4Zm10,5.5v-3c0-1.105.895-2,2-2h3c1.105,0,2,.895,2,2v3c0,1.105-.895,2-2,2h-3c-1.105,0-2-.895-2-2Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      svgColor: {
        type: String,
        default: "#000000", // Set a default fill color if not provided
      },
    },
  };
  </script>